import { uniqueId } from 'lodash-es';
import { just, nothing } from 'maybeasy';
import { computed, makeObservable, observable, runInAction } from 'mobx';

import { RootStore } from '~store/RootStore';
import { Alert } from '~types/AlertTypes';

class ToasterStore {
  rootStore: RootStore;
  alerts: Alert[] = [];
  permanentAlert: Alert | null = null;

  constructor(rootStore: RootStore) {
    makeObservable(this, {
      // Alert payloads can contain React nodes/functions that must stay non-observable.
      alerts: observable.shallow,
      permanentAlert: observable.ref,
      current: computed,
      permanent: computed,
    });

    this.rootStore = rootStore;
  }

  get current() {
    return this.alerts.length === 0 ? nothing<Alert>() : just(this.alerts[0]);
  }

  get permanent() {
    return this.permanentAlert ? just(this.permanentAlert) : nothing<Alert>();
  }

  hide() {
    runInAction(() => {
      if (this.alerts.length > 0) {
        this.alerts.splice(0, 1);
      }
    });
  }

  hidePermanentAlert() {
    runInAction(() => {
      this.permanentAlert = null;
    });
  }

  process() {
    runInAction(() => {
      this.alerts = this.alerts.slice(1);
    });
  }

  decodeHtml(message: Alert['message']) {
    if (typeof message !== 'string') {
      return message;
    }

    const textArea = document.createElement('textarea');
    textArea.innerHTML = message;

    return textArea.value;
  }

  push(alert: Alert, isHtml: boolean = false) {
    runInAction(() => {
      this.hide();

      const newAlert = {
        ...alert,
        id: uniqueId(),
        message: isHtml ? alert.message : this.decodeHtml(alert.message),
        display: true,
      };

      if (alert.isPermanent) {
        this.permanentAlert = newAlert;
      } else {
        this.alerts.push(newAlert);
      }
    });
  }

  removeFirst() {
    runInAction(() => {
      if (this.alerts.length > 0) {
        this.alerts.shift();
      }
    });
  }
}

export default ToasterStore;
